import auth from './modules/auth';
import info from './modules/info';
import history from './modules/history';
import player from './modules/player';
import audio from './modules/audio';
import banner from './modules/banner';
import notifications from './modules/notifications';
import kyc from './modules/kyc';
// import dice from './modules/dice';
import wallets from './modules/wallets';
import events from './modules/events';
import banners from './modules/smallBanners';
import affiliate from './modules/affiliate';

export default function createReducers(asyncReducers) {
  return {
    online: (v = true) => v,
    auth,
    info,
    history,
    player,
    audio,
    banner,
    notifications,
    // dice,
    events,
    banners,
    wallets,
    kyc,
    affiliate,
    ...asyncReducers,
  };
}
